import script from "./CompanyInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyInformation.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyInformation.vue?vue&type=style&index=0&id=29ac80cd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ac80cd"]])

export default __exports__